import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export default new Router({
    mode:'history',
    routes:[
        {
            path:"/",
            name:"index",
            component:() => import("@/views/index"),
            children:[{
                //诉求提交
                path:"orderSubmit",
                name:"orderSubmit",
                component:()=> import("@/views/orderSubmit"),
                meta: {
                    title: '我要诉求'
                }
            },{
                //诉求提交
                path:"szxx",
                name:"szxx",
                component:()=> import("@/views/szxx"),
                meta: {
                    title: '市长信箱'
                }
            },
            {
                //工单列表
                path:"orderList",
                name:"orderList",
                component:()=> import("@/views/orderList"),
                meta: {
                    title: '诉求列表'
                }
            },
            {
                //工单详情
                path:"orderInfo",
                name:"orderInfo",
                component:()=> import("@/views/orderInfo"),
                meta: {
                    title: '诉求详情'
                }
            },
            {
                //反映渠道
                path:"channel",
                name:"channel",
                component:()=> import("@/views/channel"),
                meta: {
                    title: '12345热线'
                }
            },
            {
                //公开列表
                path:"publicOrder",
                name:"publicOrder",
                component:()=> import("@/views/publicOrder"),
                meta: {
                    title: '办件公示'
                }
            },
            {
                //公开详情
                path:"orderInfoPublic",
                name:"orderInfoPublic",
                component:()=> import("@/views/orderInfoPublic"),
                meta: {
                    title: '诉求详情'
                }
            },
           ]
        },
        {
            path:"/404",
            name:"404",
            component:() => import("@/views/404")
        }
    ]
})
